export const GET_ONE_DRIVE = '@WEEKLY/GET_ONE_DRIVE'
export const GET_ONE_DRIVE_FOLDER_MOVE = '@WEEKLY/GET_ONE_DRIVE_FOLDER_MOVE'
export const DELETE_FILE = '@WEEKLY/DELETE_FILE'
export const CHANGE_NAME = '@WEEKLY/CHANGE_NAME'
export const CREATE_FOLDER = '@WEEKLY/CREATE_FOLDER'
export const MOVE_ITEM = '@WEEKLY/MOVE_ITEM'
export const UPLOAD_FILE = '@WEEKLY/UPLOAD_FILE'
export const GET_WEEKLY_NOTE = '@WEEKLY/GET_WEEKLY_NOTE'
export const UPDATE_WEEKLY_NOTE = '@WEEKLY/UPDATE_WEEKLY_NOTE'
export const CREATE_WEEKLY_NOTE = '@WEEKLY/CREATE_WEEKLY_NOTE'
export const GET_DRIVES_AND_NOTES = '@WEEKLY/GET_DRIVES_AND_NOTES'
export const GET_DRIVES_HOT_LOAD = '@WEEKLY/GET_DRIVES_HOT_LOAD'
export const GET_BREAD = '@WEEKLY/GET_BREAD'
export const GET_PORTFOLIO_DATA = '@WEEKLY/GET_PORTFOLIO_DATA'
export const GET_FILES_T0_DOWNLOAD_FOLDER = '@WEEKLY/GET_FILES_T0_DOWNLOAD_FOLDER'
export const REMOVE_FILES_T0_DOWNLOAD_FOLDER = '@WEEKLY/REMOVE_FILES_T0_DOWNLOAD_FOLDER'
export const UPLOAD_FOLDER = '@WEEKLY/UPLOAD_FOLDER'
export const OPEN_FILE = '@WEEKLY/OPEN_FILE'
